import {
  NumberInput,
  useRecordContext,
  SaveButton,
  SimpleForm,
  Edit,
} from 'react-admin';
import { Box, Card, Toolbar } from '@material-ui/core';
import { CardContent, Typography } from '@mui/material';
import React from 'react';

const StateEditToolbar = (props: any) => {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
};

export const State = () => {
  const ProviderView = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <pre>{JSON.stringify(record.provider, null, '\t')}</pre>;
  };

  return (
    <Card>
      <CardContent>
        <ProviderView />
        <Edit
          title="State"
          resource="state"
          actions={false}
          id="global-gbp-limit"
          mutationMode="pessimistic"
        >
          <SimpleForm toolbar={<StateEditToolbar />}>
            <Box display="flex" alignItems="center" mb={2}>
              <Typography variant="body1" style={{ marginLeft: '10px' }}>
                Remaining £ available for rewards redemption today.
              </Typography>
              <NumberInput source="gpbBalance" label={false} />
            </Box>
            <Box display="flex" alignItems="center" mb={2}>
              <Typography variant="body1" style={{ marginLeft: '10px' }}>
                Remaining £ available for rewards redemption this month.
              </Typography>
              <NumberInput source="gpbMonthlyBalance" label={false} />
            </Box>
          </SimpleForm>
        </Edit>
      </CardContent>
    </Card>
  );
};
